import { useState } from "react";
import { X, Loader2, Tag } from "lucide-react";
import useSetCashbackOfferTitle from "../../hooks/useSetCashbackOfferTitle";

export default function SetCashbackOfferTitleDialog({ onClose }) {
  const {
    setCashbackOfferTitle,
    isLoading,
    error: hookError,
  } = useSetCashbackOfferTitle();

  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");

    if (!title.trim()) {
      setError("Cashback offer title is required");
      return;
    }

    const res = await setCashbackOfferTitle({ title });

    if (res.success) {
      onClose();
    } else {
      setError(res.error || "Failed to set cashback offer title");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-200">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <div className="flex items-center gap-2">
            <Tag size={18} className="text-gray-700" />
            <h2 className="text-lg font-semibold text-gray-900">
              Set Cashback Offer Title
            </h2>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition"
          >
            <X size={18} className="text-gray-700" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-5 space-y-4">

          {/* Info box */}
          <div className="border border-gray-300 bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
            This title will be shown as the <b>active cashback offer</b> across
            the application.
          </div>

          {/* Title input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Cashback Offer Title
            </label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. Diwali Offer 🎉"
              className="w-full px-3 py-2 border rounded-lg bg-gray-50
                         focus:outline-none focus:ring-2 focus:ring-black/10"
            />
          </div>

          {(error || hookError) && (
            <p className="text-sm text-red-600">{error || hookError}</p>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 
                       text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>

          <button
            disabled={isLoading}
            onClick={handleSubmit}
            className="px-4 py-2 rounded-lg bg-black text-white 
                       flex items-center gap-2 hover:bg-gray-900 
                       transition disabled:opacity-50"
          >
            {isLoading && <Loader2 size={16} className="animate-spin" />}
            Save Title
          </button>
        </div>

      </div>
    </div>
  );
}
